import { Outlet } from "react-router-dom";
import { ThemeProvider } from "./ThemeProvide";

export default function OutletProvider() {
  return (
    <ThemeProvider>
      <Outlet />
    </ThemeProvider>
  );
}